export default {
    deleteChecklistItem:{
        isLoggedIn:false,
        data:{},
        error:null,
        loading:false,
    },
    editChecklistItem:{
        isLoggedIn:false,
        data:{},
        error:null,
        loading:false,
    },
}